import { IPolicy } from '../models/policy'

const MAIN_USER_ROLE = 'app_my_app_main_user'
const SUB_USER_ROLE = 'app_my_app_sub_user'

export const isUser = (userRoles: string[] | undefined): boolean => {
  if (!userRoles) return false

  return isSubUser(userRoles) || isMainUser(userRoles) || isImpersonatedUser(userRoles)
}

export const isMainUser = (userRoles: string[] | undefined): boolean => {
  if (!userRoles) return false

  return userRoles.includes(MAIN_USER_ROLE)
}

export const isSubUser = (userRoles: string[] | undefined): boolean => {
  if (!userRoles) return false

  return userRoles.includes(SUB_USER_ROLE)
}

export const isImpersonatedUser = (userRoles: string[] | undefined): boolean => {
  if (!userRoles) return false

  return userRoles.includes('impersonate')
}

export const calculateCombiCollectionAmount = (policies: IPolicy[]) => {
  if (!policies || policies.length === 0) return 0

  return policies.reduce((acc, policy) => {
    if (policy.premium && policy.status !== 'Opgeschort' && policy.status !== 'Geroyeerd') {
      return acc + Number.parseFloat(policy.premium)
    }

    return acc
  }, 0)
}
